import styled from '@emotion/styled'

export const StyledBanks = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`